import React, { useEffect, useState } from 'react';
import Glide from "@glidejs/glide"
import AnimatedComponent from "../Components/AnimatedComponent";
import { stagger } from "../utils/animatedVariants";
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
// Banner image
import bgbanner from "../assets/images/Slider/banner01.png"
import banner2 from '../assets/images/Slider/banner02.png'
import banner3 from '../assets/images/Slider/banner03.png'

// Images

import Gflage from "../assets/images/flage/Flag_of_Guinea.png"
import Eflage from "../assets/images/flage/us-flag.png"

// Icons
import { IoIosArrowForward } from "react-icons/io";

export default function SliderControlsInside() {
  const [isActive, setIsActive] = useState(false);
  const [selectedOption, setSelectedOption] = useState('English'); // Default selected option
  const [logocountry, setlogocountry] = useState(Gflage); // Default selected option

  const { t } = useTranslation();

  useEffect(() => {
    if (selectedOption === "Français") {
      setlogocountry(Gflage)
    } else {
      setlogocountry(Eflage)
    }
  }, [selectedOption])

  const handleOptionClick = (language, countryFlag) => {
    setSelectedOption(language); // Update the selected option
    setlogocountry(countryFlag); // Change the flag image
    i18next.changeLanguage(language === 'Français' ? 'fr' : 'en'); // Change the i18next language
    setIsActive(false); // Close the dropdown
  };

 

  useEffect(() => {
    const slider = new Glide(".glide-01", {
      type: "slider",
      focusAt: "center",
      perView: 1,
      autoplay: 5000,
      animationDuration: 1000,
      gap: 0,
      classes: {
        nav: {
          active: "[&>*]:bg-wuiSlate-700",
        },
      },
    }).mount()

    return () => {
      slider.destroy()
    }
  }, [])


  

  return (
    <>
      {/*<!-- Component: Slider with controls inside --> */}
      <div className={'relative w-full glide-01 lg-max:pt-[78px]'}>
        {/*    <!-- Slides --> */}
        <div className={'overflow-hidden relative'} data-glide-el="track">
          <ul className={' whitespace-no-wrap flex-no-wrap [backface-visibility: hidden] [transform-style: preserve-3d] [touch-action: pan-Y] [will-change: transform] relative flex w-full overflow-hidden p-0'}>
            <li className={'relative'}>
              <img
                src={bgbanner}
                className={'w-full max-w-full max-h-full  m-auto'}
                alt={'Slide 1'}
              />
              <div className={'absolute bg-[#051b34ba] inset-0 bg-violet-500/90 z-5'}></div>
              <div className={'w-60p flex items-center justify-center h-full absolute right-0 top-0  text-center text-white '}>

                <AnimatedComponent
                  tag="div"
                  variants={stagger("negative")}
                  className={'leading-loose text-left'}>
                  <div className={'relative   flex items-center justify-end 2xl-max:!justify-end xl-max:!justify-end z-20'}>
                    <div className={'space-y-6  slide-text sm:py-0'}>
                      <h2 className="Heading-01 text-left">
                      {t("main.Slider.Heading01")}
                      {/* Happiness, Sharing, Simplicity. */}

                      </h2>
                      {/* <h4 className="heading-title text-left 2xl:!text-[30px] xl:!text-[25px] lg:!text-[22px] md:!text-[18px] sm:!text-[14px] ">Quick and Easy Transfers</h4> */}
                      <p className={'heading-para !text-[#cdcdcd] w-[90%] text-left'}>{t("main.Slider.para_head_01")}</p>
                      <button
                        className={'bbt inline-flex border-[3px] rounded-sm items-center justify-center hover:before:bg-redborder-red-500 relative px-3 h-[54px] md-max:!h-[40px] overflow-hidden  border-whire bg-white/0 text-white  transition-all before:absolute before:bottom-0 before:left-0 before:top-0 before:z-0 before:h-full before:w-0 before:bg-gradient-to-r from-[#fe7b05] to-[#eabb76] before:transition-all before:duration-500 hover:text-white hover:before:left-0 hover:before:w-full !hover:rounded-[4px] hover:border-white/0'}>
                        <span className={'flex items-center justify-center relative z-10 text-left text-[15px] md-max:!text-[12px] sm-max:!text-[10px]'}>
                        {t("main.Slider.Get_started_now")} <IoIosArrowForward className={'ml-2 '} />
                        </span>
                      </button>


                    </div>
                  </div>
                </AnimatedComponent>

              </div>
            </li>
            <li className={'relative'}>
              <img
                src={banner2}
                className={'w-full max-w-full max-h-full m-auto'}
                alt={'Slide 2'}
              />
               <div className={'absolute bg-[#051b34ba] inset-0 bg-violet-500/90 z-5'}></div>
              <div className={'w-60p flex items-center justify-center h-full absolute right-0 top-0  text-center text-white '}>

                <AnimatedComponent
                  tag="div"
                  variants={stagger("negative")}
                  className={'leading-loose text-left'}>
                  <div className={'relative  flex items-center justify-end z-20'}>
                    <div className={'space-y-6  text-left'}>
                    <h2 className="Heading-01 text-left">
                    {t("main.Slider.Heading_02")}
                      </h2>
                      {/* <h4 className="heading-title">Streamlined Payment Solutions</h4> */}
                      <p className={'heading-para text-[#cdcdcd] w-[80%] lg-max:hidden text-left 2xl:!text-[16px] xl:!text-[14px] lg:!text-[12px] md:!text-[11px] sm:!text-[11px] xs:!hidden'}>
                      {t("main.Slider.para_head_02")}
                      </p>
                      <button
                        className={'bbt inline-flex border-[3px] rounded-sm items-center justify-center hover:before:bg-redborder-red-500 relative px-3 h-[54px] md-max:!h-[40px]  overflow-hidden  border-whire bg-white/0 text-white  transition-all before:absolute before:bottom-0 before:left-0 before:top-0 before:z-0 before:h-full before:w-0 before:bg-gradient-to-r from-[#fe7b05] to-[#eabb76] before:transition-all before:duration-500 hover:text-white hover:before:left-0 hover:before:w-full !hover:rounded-[4px] hover:border-white/0'}>
                        <span className={'flex items-center justify-center relative z-10 text-[15px] md-max:!text-[12px] sm-max:!text-[10px]'}>
                        {t("main.Slider.Get_started_now")} <IoIosArrowForward className={'ml-2 md-max:!text-[12px]'} />
                        </span>
                      </button>


                    </div>
                  </div>
                </AnimatedComponent>

              </div>
            </li>
            {/* Add more slides with captions here */}

            <li className={'relative'}>
              <img
                src={banner3}
                className={'w-full max-w-full max-h-full m-auto'}
                alt={'Slide 2'}
              />
               <div className={'absolute bg-gradient-to-r from-[#051b34c5]   inset-0 bg-violet-500/90 z-5'}></div>
              <div className={'w-60p flex items-center justify-center h-full absolute left-0 top-0  text-center text-white pl-8'}>

                <AnimatedComponent
                  tag="div"
                  variants={stagger("negative")}
                  className={'leading-loose text-left'}>
                  <div className={'relative  flex items-center justify-end z-20'}>
                    <div className={'space-y-6  text-left'}>
                    <h2 className="Heading-01 text-left">
                    {t("main.Slider.Heading_03")}
                      </h2>
                      {/* <h4 className="heading-title"> </h4> */}
                      <p className={'heading-para text-[#cdcdcd] w-[90%] text-left 2xl:!text-[16px] xl:!text-[14px] lg:!text-[12px] md:!text-[11px] sm:!text-[11px] xs:!hidden'}>
                      {t("main.Slider.para_head_03")}
                      </p>
                      <button
                        className={'bbt inline-flex border-[3px] rounded-sm items-center justify-center hover:before:bg-redborder-red-500 relative px-3 h-[54px] overflow-hidden  border-whire bg-white/0 text-white  transition-all before:absolute before:bottom-0 before:left-0 before:top-0 before:z-0 before:h-full before:w-0 before:bg-gradient-to-r from-[#fe7b05] to-[#eabb76] before:transition-all before:duration-500 hover:text-white hover:before:left-0 hover:before:w-full !hover:rounded-[4px] hover:border-white/0'}>
                        <span className={'flex items-center justify-center relative z-10 text-[15px] md-max:!text-[12px] sm-max:!text-[10px]'}>
                        {t("main.Slider.download_app_now")} <IoIosArrowForward className={'ml-2 md-max:!text-[12px]'} />
                        </span>
                      </button>


                    </div>
                  </div>
                </AnimatedComponent>

              </div>
            </li>
            {/* Add more slides with captions here */}
          </ul>
        </div>
         {/*    <!-- Controls --> */}
         <div className="absolute left-0 flex items-center justify-between w-full h-0 px-4 top-1/2" data-glide-el="controls">
          <button
            className="inline-flex items-center justify-center w-8 h-8 transition duration-300 border rounded-full border-slate-700 bg-white/20 text-slate-700 hover:border-slate-900 hover:text-slate-900 focus-visible:outline-none lg:h-12 lg:w-12"
            data-glide-dir="<"
            aria-label="prev slide"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
              <title>prev slide</title>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
            </svg>
          </button>
          <button
            className="inline-flex items-center justify-center w-8 h-8 transition duration-300 border rounded-full border-slate-700 bg-white/20 text-slate-700 hover:border-slate-900 hover:text-slate-900 focus-visible:outline-none lg:h-12 lg:w-12"
            data-glide-dir=">"
            aria-label="next slide"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
              <title>next slide</title>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
            </svg>
          </button>
        </div>
      </div>
      {/*<!-- End Slider with controls inside --> */}
    </>
  )
}